import React, { useState, useCallback } from 'react'
import Menu from './Menu'
import ButtonWithMenu from '../ButtonWithMenu'

const AnalyzeSection = ({ className, active }) => {
  const [open, setOpen] = useState(false)

  const handleCloseMenu = useCallback(() => {
    setOpen(false)
  }, [])
  return (
    <ButtonWithMenu
      css={className}
      isActive={active === 'Reporting'}
      open={open}
      setOpen={setOpen}
      overlay={<Menu onClose={handleCloseMenu} />}
      dataTestId="Reporting"
    >
      Reports
    </ButtonWithMenu>
  )
}

export default AnalyzeSection
